import { fullDate } from '../format';

/** "YYYY-MM-DD" plus `days` (UTC calendar arithmetic, no time zones). */
export function addDays(date: string, days: number): string {
  const d = new Date(`${date}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** The Monday of the week containing `date` (Monday = 1st day). */
export function mondayOf(date: string): string {
  const day = new Date(`${date}T12:00:00Z`).getUTCDay(); // 0 = Sunday
  return addDays(date, -((day + 6) % 7));
}

export type WeekChoice = { end: string; label: string };

/**
 * The weekly report covers the 7 days before `end` (arqam doc 44): a week
 * Monday → Sunday is asked for with `end` = the following Monday. Choices:
 * the last 7 days up to `today`, then the last `count` complete weeks, the
 * latest first.
 */
export function weekChoices(today: string, count = 8): WeekChoice[] {
  const lastMonday = mondayOf(today);
  const weeks: WeekChoice[] = [];
  for (let i = 0; i < count; i++) {
    const end = addDays(lastMonday, -7 * i); // Monday after the week
    const start = addDays(end, -7);
    weeks.push({ end, label: weekLabel(start, addDays(end, -1)) });
  }
  return [
    ...weeks,
    { end: addDays(today, 1), label: 'الأيام السبعة الأخيرة (حتى اليوم)' },
  ];
}

/** «13 – 19 أكتوبر 2026», or across months «29 شتنبر – 5 أكتوبر 2026». */
function weekLabel(monday: string, sunday: string): string {
  const [from, to] = [fullDate(monday), fullDate(sunday)];
  const fromParts = from.split(' ');
  const toParts = to.split(' ');
  if (fromParts.slice(1).join(' ') === toParts.slice(1).join(' ')) {
    return `${fromParts[0]} – ${to}`;
  }
  if (fromParts[2] === toParts[2]) {
    return `${fromParts.slice(0, 2).join(' ')} – ${to}`;
  }
  return `${from} – ${to}`;
}
